export default {
  data() {
    return {
      uploadGuideVisible: false,
      uploadGuideVersion: '2',
      largeUploadNoticeShown: false,
    };
  },
  methods: {
    getUploadGuideStorageKey() {
      return 'runpixie:photo-upload-guide-version';
    },
    showUploadGuideIfNeeded() {
      if (!this.user || this.uploadGuideVisible) {
        return;
      }
      try {
        const seenVersion = localStorage.getItem(this.getUploadGuideStorageKey());
        if (seenVersion === this.uploadGuideVersion) {
          return;
        }
      } catch {
        // The guide is optional; storage restrictions must not affect uploading.
      }
      this.uploadGuideVisible = true;
    },
    openUploadGuide() {
      this.uploadGuideVisible = true;
    },
    closeUploadGuide() {
      this.uploadGuideVisible = false;
    },
    markUploadGuideSeen() {
      try {
        localStorage.setItem(this.getUploadGuideStorageKey(), this.uploadGuideVersion);
      } catch {
        // Ignore private-mode/storage errors.
      }
    },
    maybeShowLargeUploadNotice(count) {
      if (
        count < 1000 ||
        this.largeUploadNoticeShown ||
        this.pendingResumeSummary ||
        this.resumeAwaitingReselection
      ) {
        return;
      }
      this.largeUploadNoticeShown = true;
      this.$q.notify({
        icon: 'info',
        color: 'info',
        timeout: 7000,
        message: this.$t('addMedia.guide.largeUploadNotice', { count }),
        position: 'top-right',
      });
    },
  },
};
